import React from 'react';
import classnames from 'classnames';
import './BulletList.scss';
import PropTypes from 'prop-types';

const BulletList = props => {
  return (
    <ul
      className={classnames(
        'bulletListCmp',
        props.paddingLeftClass,
        props.className,
      )}
    >
      {props.children}
    </ul>
  );
};

BulletList.propTypes = {
  paddingLeftClass: PropTypes.string,
};

BulletList.defaultProps = {
  paddingLeftClass: 'padL8',
};

export default BulletList;
